import { ASSESSMENT_POSTERIOR } from '../constants';
import type { AssessmentPosteriorType, IAssessmentAnswerSignal } from '../types';
import { validateAssessmentPosterior } from './validate-assessment-posterior';

function probabilityOfCorrectAnswer(ability: number, difficulty: number): number {
  return 1 / (1 + 10 ** ((difficulty - ability) / ASSESSMENT_POSTERIOR.difficultyScale));
}

export function updateAssessmentPosterior(
  posterior: AssessmentPosteriorType,
  signal: IAssessmentAnswerSignal,
): AssessmentPosteriorType {
  validateAssessmentPosterior(posterior);
  const weighted = posterior.map((point) => {
    const probabilityCorrect = probabilityOfCorrectAnswer(point.ability, signal.difficulty);
    const likelihood = signal.correct ? probabilityCorrect : 1 - probabilityCorrect;
    return { ability: point.ability, probability: point.probability * likelihood };
  });
  const totalProbability = weighted.reduce((sum, point) => sum + point.probability, 0);
  if (!Number.isFinite(totalProbability) || totalProbability <= 0) {
    throw new Error('Assessment posterior must contain positive probability mass');
  }
  return Object.freeze(
    weighted.map((point) =>
      Object.freeze({ ...point, probability: point.probability / totalProbability }),
    ),
  );
}
